module.exports = __webpack_public_path__ + "img/3.3.TP.68c42e5f.png";